export const bar_chart = () => (
  <path
    d="M18 20V10m-6 10V4M6 20v-6"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
